export default "__VITE_ASSET__tomlTyJA__"